export default __webpack_public_path__ + "static/gunner-6ac66a15347cb6d98202144dc987cd40.png";